const userData = [
  {
    name: "Sandeep Suman",
    ghurl: "https://github.com/SandeepKrSuman",
    imgName: "jokeGenerator.gif",
    folderName: "SandeepJokeGenerator",
    projectTitle: "Joke Generator",
  },
  {
    name: "Sandeep Suman",
    ghurl: "https://github.com/SandeepKrSuman",
    imgName: "httpCats.png",
    folderName: "SandeepHttpCats",
    projectTitle: "HTTP Cats",
  },
  {
    name: "Abhay Pareek",
    ghurl: "https://github.com/Abhaypareek170",
    imgName: "AbhaySimonGame.gif",
    folderName: "AbhaySimonGame",
    projectTitle: "Simon Game",
  },
  {
    name: "Jej",
    ghurl: "https://github.com/jej-v",
    imgName: "JejMousePointer.gif",
    folderName: "JejMousePointer",
    projectTitle: "Mouse Pointer",
  },
  {
    name: "Vaibhav Tyagi",
    ghurl: "https://github.com/06vavy",
    imgName: "VaibhavPalinCheck.png",
    folderName: "VaibhavPalindromeCheck",
    projectTitle: "Palindrome Check",
  },
  {
    name: "Shubham Choubey",
    ghurl: "https://github.com/ishubham010",
    imgName: "ShubhamTicTacToe.gif",
    folderName: "ShubhamTicTacToe",
    projectTitle: "Tic-Tac-Toe",
  },
  {
    name: "Parinthapat Pengpun",
    ghurl: "https://github.com/parinzee",
    imgName: "ParinzeeMicrosoftLogo.gif",
    folderName: "ParinzeeMicrosoftLogo",
    projectTitle: "Microsoft Logo",
  },
  {
    name: "Yang Wei Hao",
    ghurl: "https://github.com/whyang0808",
    imgName: "stopWatch.gif",
    folderName: "WeiHaoStopWatch",
    projectTitle: "Stop Watch",
  },
  {
    name: "Utkarsh Maurya",
    ghurl: "https://github.com/Uttkarrsh",
    imgName: "UtkarshBMICalculator.gif",
    folderName: "UtkarshBMICalculator",
    projectTitle: "BMI Calculator",
  },
  {
    name: "Swarnit Sinha",
    ghurl: "https://github.com/SwarnitSinha",
    imgName: "swarnit_temperature_converter.png",
    folderName: "SwarnitTempConverter",
    projectTitle: "Temperature Converter",
  },
  {
    name: "Ayush Aryan",
    ghurl: "https://github.com/aryanayush012",
    imgName: "Ayush_aryan_Drum_Kit_Project.gif",
    folderName: "Ayush_aryan_Drum_Kit_Project",
    projectTitle: "Drum Kit",
  },
  {
    name: "Aman Singh",
    ghurl: "https://github.com/amansingh1373",
    imgName: "counterproject.png",
    folderName: "AmanCounter",
    projectTitle: "Counter",
  },
  {
    name: "Abhishek Rohit",
    ghurl: "https://github.com/imabhishek02",
    imgName: "AbhishekBlackJack.gif",
    folderName: "AbhishekBlackJack",
    projectTitle: "BlackJack Game",
  },
  {
    name: "Ahmed Hinedy",
    ghurl: "https://github.com/hinedy",
    imgName: "HinedyRomanConverter.png",
    folderName: "HinedyRomanConverter",
    projectTitle: "Roman Numeral Converter",
  },
  {
    name: "Satish Yadav",
    ghurl: "https://github.com/Satish8981",
    imgName: "Satish_Snake_Game.gif",
    folderName: "Satish_Snake_Game",
    projectTitle: "Snake Game",
  },
  {
    name: "Charandeep Kumar",
    ghurl: "https://github.com/charandeep7",
    imgName: "CharandeepTimer.gif",
    folderName: "CharandeepTimer",
    projectTitle: "Timer",
  },
  {
    name: "Giulia Amaral",
    ghurl: "https://github.com/giuliaamaral",
    imgName: "catgame.gif",
    folderName: "GiuliaCatGame",
    projectTitle: "Cat Game",
  },
  {
    name: "Umang Singla",
    ghurl: "https://github.com/umang-singla",
    imgName: "Umang15PuzzleGame.jpeg",
    folderName: "Umang15PuzzleGame",
    projectTitle: "Sliding Puzzle",
  },
  {
    name: "Carol Brum",
    ghurl: "https://github.com/brumcaroline",
    imgName: "MarioJump.jpg",
    folderName: "CarolBrumMarioJump",
    projectTitle: "Mario Jump",
  },
  {
    name: "Swapnil Aichbhaumik",
    ghurl: "https://github.com/Swap-nil-2003",
    imgName: "SwapnilAichbhaumik_QuizWebApp.png",
    folderName: "SwapnilAichbhaumik_QuizWebApp",
    projectTitle: "Quiz Web App",
  },
  {
    name: "Iman Crooks",
    ghurl: "https://github.com/iqtheengineer",
    imgName: "bigfoot.gif",
    folderName: "IQtheEngineerBigfootGame",
    projectTitle: "Can You Find Bigfoot? Game",
  },
  {
    name: "Rajeev Krishna",
    ghurl: "https://github.com/radzhiv25",
    imgName: "QrCodeReader.gif",
    folderName: "RadzhivQrReader",
    projectTitle: "Qr Code Reader",
  },
  {
    name: "Swaraj",
    ghurl: "https://github.com/swarajzz",
    imgName: "GuessMyNumber.png",
    folderName: "SwarajGuessMyNumber",
    projectTitle: "Guess My Number Game",
  },
  {
    name: "Muzhar Hussain",
    ghurl: "https://github.com/muzhar01",
    imgName: "top100.png",
    folderName: "MuzharTop100",
    projectTitle: "Top 100 Songs",
  },
  {
    name: "Glória Brito",
    ghurl: "https://github.com/GloBrito",
    imgName: "WordleGloria.png",
    folderName: "WordleGloria",
    projectTitle: "Wordle Game",
  },
  {
    name: "Shreyan Mjumdar",
    ghurl: "https://github.com/Shreyan-12345",
    imgName: "DiceGame.png",
    folderName: "ShreyanDiceGame",
    projectTitle: "Dice Game",
  },
  {
    name: "Subhashis Paul",
    ghurl: "https://github.com/subhashis2204",
    imgName: "SubhashisWordCounter.png",
    folderName: "SubhashisWordCounter",
    projectTitle: "Word Counter",
  },
  {
    name: "Shreyan Mjumdar",
    ghurl: "https://github.com/Shreyan-12345",
    imgName: "Hangman.png",
    folderName: "ShreyanHangmanGame",
    projectTitle: "Hangman Game",
  },
  {
    name: "Iman Crooks",
    ghurl: "https://github.com/iqtheengineer",
    imgName: "MagicEightBall.gif",
    folderName: "IQtheEngineer8Ball",
    projectTitle: "Magic 8 Ball",
  },
  {
    name: "Rubens Flinco",
    ghurl: "https://github.com/rubensflinco",
    imgName: "GameBreakBlocks.png",
    folderName: "GameBreakBlocks",
    projectTitle: "Game Break Blocks",
  },
  {
    name: "Gabriel Alves Vitebo",
    ghurl: "https://github.com/gabriel-vitebo",
    imgName: "TimerFocus.png",
    folderName: "GabrielTimerFocus",
    projectTitle: "Focus Timer 2.0",
  },
];

export { userData };
